import { createFileRoute } from '@tanstack/react-router';
import { TasterPage } from '@/features/taster/TasterPage';

export const Route = createFileRoute('/try')({
  component: TasterPage,
});
